import { render, staticRenderFns } from "./OnlCgformCopyList.vue?vue&type=template&id=ada9b51c&scoped=true&"
import script from "./OnlCgformCopyList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformCopyList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformCopyList.vue?vue&type=style&index=0&id=ada9b51c&prod&scoped=true&lang=css&"
import style1 from "./OnlCgformCopyList.vue?vue&type=style&index=1&id=ada9b51c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada9b51c",
  null
  
)

export default component.exports